const calcCheckDigit = (base: string): number => {
	let factor = base.length + 1;
	let total = 0;
	for (const digit of base) {
		total += parseInt(digit, 10) * factor--;
	}
	const remainder = (total * 10) % 11;
	return remainder === 10 ? 0 : remainder;
};

export const isValidCpf = (value: string): boolean => {
	const digits = String(value ?? "").replace(/\D/g, "");

	if (digits.length !== 11) return false;
	if (/^(\d)\1{10}$/.test(digits)) return false;

	const base9 = digits.slice(0, 9);
	const digit1 = calcCheckDigit(base9);
	const digit2 = calcCheckDigit(base9 + digit1);

	return digits === base9 + digit1.toString() + digit2.toString();
};
